export const grids = {
  1: 'gridSimilarAssetsColumns',
  2: 'gridFirmColumns',
  3: 'gridSharedColumns',
  4: 'gridSurveyAssetsColumns',
  5: 'gridTaxAuthorityColumns',
}
